<template>
  <Dialog v-model:visible="themeDialogVisible" modal :style="{ width: '50rem' }" :closable="false">
    <template #header>
      <TabView style="width: 100%">
        <TabPanel header="General">
          <GeneralStyle />
        </TabPanel>
        <TabPanel header="AI Button">
          <AiButtonStyle />
        </TabPanel>
      </TabView>
    </template>

    <template #footer>
      <Button label="Cancel" severity="secondary" @click="themeDialogVisible = false" />
    </template>
  </Dialog>
</template>
<script setup lang="ts">
import AiButtonStyle from "@/components/ThemeEditorTabs/AiButtonStyle.vue";
import GeneralStyle from "@/components/ThemeEditorTabs/GeneralStyle.vue";
import { computed } from "vue";

const props = defineProps({
  dialogVisible: Boolean,
})
const emit = defineEmits(["update:dialogVisible"])

const themeDialogVisible = computed({
  get() {
    return props.dialogVisible ?? false;
  },
  set(val) {
    emit("update:dialogVisible", val)
  },
})

</script>

<style scoped lang="scss">
:deep(.p-tabview-panels) {
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 400px;
}
</style>